import moment from 'moment-timezone';

const BOOKING_CONTEXT_KEYS = ['clinicianId', 'cptCodeId', 'officeId'];

function bookingContextFromReservation(reservation) {
  if (!reservation) return null;

  return {
    clinicianId: reservation.get('clinician.id'),
    cptCodeId: reservation.get('cptCode.id'),
    officeId: reservation.get('office.id'),
  };
}

function bookingContextFromQueryParams(queryParams = {}) {
  return {
    clinicianId: queryParams.clinicianId,
    cptCodeId: queryParams.cptCodeId,
    officeId: queryParams.officeId,
  };
}

function idString(value) {
  return value !== undefined && value !== null && value !== '' ? String(value) : undefined;
}

function sameBookingId(bookedId, contextId) {
  if (bookedId === undefined || bookedId === null || bookedId === '') return true;
  if (contextId === undefined || contextId === null || contextId === '') return false;

  return String(bookedId) === String(contextId);
}

function matchesRecentlyBookedSlot(selectedSlot, recentlyBookedSlot, context) {
  if (!selectedSlot || !recentlyBookedSlot) return false;

  let bookedTime =
    typeof recentlyBookedSlot === 'string' ? recentlyBookedSlot : recentlyBookedSlot.startTime;
  if (!bookedTime || !moment(selectedSlot).isSame(moment(bookedTime))) return false;

  if (typeof recentlyBookedSlot !== 'object') return true;
  if (!context) return false;

  return BOOKING_CONTEXT_KEYS.every(key => sameBookingId(recentlyBookedSlot[key], context[key]));
}

export function recentlyBookedSlotFromReservation(reservation) {
  if (!reservation?.startTime) return null;

  return {
    startTime: reservation.startTime,
    clinicianId: idString(reservation.get('clinician.id')),
    cptCodeId: idString(reservation.get('cptCode.id')),
    officeId: idString(reservation.get('office.id')),
  };
}

export function isStaleBookedQueryParam(queryParams = {}, recentlyBookedSlot) {
  return matchesRecentlyBookedSlot(
    queryParams.selectedSlot,
    recentlyBookedSlot,
    bookingContextFromQueryParams(queryParams)
  );
}

export function isStaleBookedForReservation(selectedSlot, recentlyBookedSlot, reservation) {
  return matchesRecentlyBookedSlot(
    selectedSlot,
    recentlyBookedSlot,
    bookingContextFromReservation(reservation)
  );
}

function sameIdWhenPresent(leftId, rightId) {
  let normalizedLeft = idString(leftId);
  let normalizedRight = idString(rightId);

  return !normalizedLeft || !normalizedRight || normalizedLeft === normalizedRight;
}

function sameClinicianWhenPresent(appointment, recentlyBookedSlot) {
  if (typeof recentlyBookedSlot !== 'object') return true;

  return sameIdWhenPresent(recentlyBookedSlot.clinicianId, appointment.get('clinician.id'));
}

export function isRecentlyBookedAppointment(appointment, recentlyBookedSlot) {
  let bookedTime =
    typeof recentlyBookedSlot === 'string' ? recentlyBookedSlot : recentlyBookedSlot?.startTime;

  if (!appointment?.startTime || !bookedTime) return false;

  return (
    moment(appointment.startTime).isSame(moment(bookedTime)) &&
    sameClinicianWhenPresent(appointment, recentlyBookedSlot)
  );
}
